"use strict";

var _Object$keys2 = require("@babel/runtime-corejs2/core-js/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getDOMAttributesForListBox = getDOMAttributesForListBox;
exports.getDOMAttributesForListBoxButton = exports.getA11yAttributesForOption = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

function ownKeys(object, enumerableOnly) { var keys = _Object$keys2(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

function getDOMAttributesForListBox(_ref) {
  var idListBox = _ref.idListBox,
      refLabel = _ref.refLabel,
      activeOption = _ref.activeOption,
      isInline = _ref.isInline,
      isMulti = _ref.isMulti,
      options = _ref.options;
  var activedescendant = "";

  if (activeOption && activeOption < (0, _keys["default"])(options).length) {
    var id = options[activeOption].id;

    if (id) {
      activedescendant = id;
    }
  }

  var bestLabel = refLabel && refLabel.current ? "".concat(refLabel.current.getAttribute("id"), " ").concat(idListBox, "__label") : "".concat(idListBox, "__label");
  return {
    "aria-activedescendant": activedescendant,
    "aria-labelledby": bestLabel,
    "aria-multiselectable": isMulti ? "true" : null,
    id: isInline ? idListBox : "".concat(idListBox, "__content")
  };
}

var getA11yAttributesForOption = function getA11yAttributesForOption(isSelected) {
  var a11yIsSelected = {
    "aria-selected": "".concat(isSelected ? "true" : "false")
  };
  return _objectSpread({
    role: "option"
  }, a11yIsSelected);
};

exports.getA11yAttributesForOption = getA11yAttributesForOption;

var getDOMAttributesForListBoxButton = function getDOMAttributesForListBoxButton(_ref2) {
  var idListBox = _ref2.idListBox,
      idFormLabel = _ref2.idFormLabel,
      isOpen = _ref2.isOpen;
  return {
    "aria-controls": "".concat(idListBox, "__content"),
    "aria-haspopup": true,
    "aria-expanded": isOpen,
    "aria-labelledby": idFormLabel ? "".concat(idFormLabel, " ").concat(idListBox, "__label") : null,
    id: idListBox
  };
};

exports.getDOMAttributesForListBoxButton = getDOMAttributesForListBoxButton;
//# sourceMappingURL=DOMAttributes.js.map